"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcquisitionChannel = void 0;
var AcquisitionChannel;
(function (AcquisitionChannel) {
    AcquisitionChannel["API_V2"] = "API_V2";
    AcquisitionChannel["API_V3"] = "API_V3";
    AcquisitionChannel["WEBSITE"] = "WEBSITE";
    AcquisitionChannel["UNKNOWN"] = "UNKNOWN";
    AcquisitionChannel["APP"] = "APP";
    AcquisitionChannel["MANAGEMENT"] = "MANAGEMENT";
    AcquisitionChannel["TA"] = "TA";
    AcquisitionChannel["DRIVER_APP"] = "DRIVER_APP";
    AcquisitionChannel["CI"] = "CI";
})(AcquisitionChannel || (exports.AcquisitionChannel = AcquisitionChannel = {}));
//# sourceMappingURL=acquisition-channel.enum.js.map